///include /assets/js/app/p/domain-contact-requirements.js
///include /assets/js/plugins/dac-parts.js
///include /assets/js/plugins/components/custom-radio.js

"use strict"

const DomainSearch = Vue.extend({
    delimiters: ["[[", "]]"],
    name: "CategoryDomainSearch",
    props: {
        defaultYears: {
            type: Number,
            required: false,
            default: 2,
        },
        option: {
            type: String,
            required: false,
            default: 'register',
        },
        search: {
            type: [PointerEvent, null],
            required: false,
            default: null
        },
        searchQuick: {
            type: [Event, null],
            required: false,
            default: null
        },
        domainRequired: {
            type: Boolean,
            required: false,
            default: false
        },
        singleDomain: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data() {
        const vue = this
        return {
            contactRequirements: _DOMAIN_CONTACT_REQUIREMENTS,
            aiSearchBarValue: "",
            basketClient: AnyBasket.inst,
            /** @type {AnyDomainStore} */
            domainStore: AnyDomainStore.inst,
            /** @type {?string} */
            expandedDomainSearchDomain: null,
            filters: [],
            generatingAiSuggestions: false,
            initialBuild: false,
            initialSearch: null,
            initialDomains: [
                ".co.uk",".com",".uk",".org.uk",".net",".org",".co",".info",".me.uk",".online"
            ],
            /** @type {?XMLHttpRequest} */
            lastRequest: null,
            /** @type {?NodeJS.Timeout} */
            lookupWait: null,
            maxPrice: 0.00,
            maxPriceDebounceTimeout: null,
            maxPriceRemovesRemainder: false,
            multiSearch: false,
            searchBarValue: "",
            /** @type {DomainResult[]} */
            searchResults: [],
            selectedCategory: ["Popular"],
            selectedsingleCategory: null,
            showAvailable: "all",
            sortByOptions: [
                { id: 'recommended', text: 'Recommended' },
                { id: 'domain', text: 'Alphabetical' },
                { id: 'price', text: 'Price (low to high)' }
            ],
            availableOptions: [
                { id: 'all', text: 'All' },
                { id: 'register', text: 'Available' },
                { id: 'transfer', text: 'Taken' },
            ],
            /** @type {?string} */
            sortOrder: 'recommended',
            /** @type {?boolean} */
            startLoadedSearchDone: null,
            useAiSearch: false,
            /** @type {string[]} */
            undeleted: [],
            // ? Not sure why this is here - doesn't seem to be set..
            user: null,
            // ..create a separate one instead
            userInst: User.inst,
            async toggle_brandProtect_basket() {
                for( var d of this.brandProtectDomains ){
                    d.selected_years = this.inauguralDomain.selected_years;
                    if( !d.basketItem ){
                        var f = await d.addToBasket(true);
                    }
                }
            },
            get addBrandDomainsStatus() {
                var basket = 0;
                for( var d of this.brandProtectDomains ){
                    if( d.status.in_basket ){
                        basket++;
                    }
                }
                return basket == this.brandProtectDomains.length ? "in_basket" : "";
            },
            get brandProtectDomains() {
                var allowedBrandDomains = [".uk",".co.uk",".com",".org",".net","online"];
                if( this.searchResults && this.inauguralDomain && this.inauguralDomain.status.can.match(/register/) ){
                    var possible = this.searchResults.filter( (r) => {
                        // We dont want the domain they searched for. Or any domain
                        // that isn't *definitively* registerable - this must be a
                        // positive check for "register" so that domains which are
                        // still loading (status.can === null) or that resolve to a
                        // non-register value (e.g. "transfer?", meaning already
                        // registered) are excluded rather than shown as available.
                        if( r.name == this.inauguralDomain.name || !(r.status && r.status.can && r.status.can.match(/register/)) ){
                            return false;
                        }
                        return allowedBrandDomains.includes(r.tld);
                    } );

                    return possible.sort( (a,b) => {
                        return allowedBrandDomains.indexOf(a.tld) - allowedBrandDomains.indexOf(b.tld);
                    } ).splice(0,3);
                } else {
                    return [];
                }
            },
            get brandProtectDomainOptions() {
                var options = [];

                var validYears = [];
                for( var year = 1; year <= 10; year++ ){
                    var valid = true;
                    for( var d of this.brandProtectDomains ){
                        if( !this.domainStore.yearsByTld[d.tld].includes(year) ){
                            valid = false;
                        }
                    }
                    if( valid ){
                        validYears.push(year);
                    }
                }


                for(var year of validYears) {
                    var totalDomainPrice = 0.00;
                    for( var d of this.brandProtectDomains ){
                        var yearlyPrice;
                        if( this.domainStore.userInfo && this.domainStore.userInfo.isReseller ){
                            yearlyPrice = parseFloat(this.domainStore.productByTld[d.tld].pricing.card.yearly.reseller.purchase);
                        } else {
                            yearlyPrice = parseFloat(this.domainStore.productByTld[d.tld].pricing.card.yearly.non_reseller.purchase);
                        }
                        totalDomainPrice+= yearlyPrice * year;
                    }
                    options.push({
                        text: year + " " + (year > 1 ? "years" : "year") + " for " + Site.Format.price(totalDomainPrice, this.basketClient.currency),
                        id: year
                    });
                }
                return options;
            },

            get basketSubTotalBeforeTax() {
                if (!this.basketClient || !this.basketClient.items) {
                    return null
                }

                return Site.Format.price(this.basketClient.content['total-excluding-vat'], this.basketClient.currency)
            },

            /** @type {boolean} */
            get can_select_all() {
                return this.domainList.some(
                    d => d.mayAddToBasket
                )
            },
            /** @type {?string[]} */
            get categorylist() {
                if (!this.domainCategory) {
                    return null
                }

                const categories = Object.keys(this.domainCategory).sort()
                const hasPopular = categories.indexOf('Popular')
                const hasNew = categories.indexOf('New')

                if (hasNew) {
                    categories.splice(hasNew, 1)
                    categories.unshift('New')
                }

                if (hasPopular) {
                    categories.splice(hasPopular, 1)
                    categories.unshift('Popular')
                }

                return categories
            },
            /**
             * @type {boolean}
             */
            get checked_domains() {
                return this.domainList.some(d => d.status.checked)
            },
            /** @type {DomainResult[]} */
            get selectedDomains() {
                return this.domainList.filter(d => d.status.checked)
            },
            /** @type {number} */
            get selectedDomainsCount() {
                return this.selectedDomains.length
            },
            get selectedDomainsSubTotal() {
                if (!this.basketClient || !this.selectedDomainsCount) {
                    return null
                }

                const total = this.selectedDomains.reduce(
                    (sum, d) => sum + (
                        d.status.product ?
                            d.status.product.priceForYears(d.selected_years, d.status.discoveredPrice, d.status.discountCode) :
                            0
                    ),
                    0
                )

                return Site.Format.price(total, this.basketClient.currency)
            },
            /**
             * @type {boolean}
             */
            get contactFormAvailable() {
                //@ts-ignore
                const brand = window.brand
                return brand && brand.togglePrefs && brand.togglePrefs.contactForm
            },
            get domainCategory() {
                return this.domainStore instanceof DomainStore ? domain_categories(this.basketClient.currency) : this.domainStore.domainCategory
            },
            get notHiddenSearchResults() {
                // "policy-block" names are forbidden by registry policy (e.g.
                // "me.co.uk"); hide them entirely rather than show an
                // unactionable row.
                return this.searchResults.filter(
                    r => !r.hidden && r.status.can !== 'policy-block'
                )
            },
            // The set of results currently in view, before the availability
            // and max-price filters are applied. Shared by domainList and
            // getAvailabilityCount so the tab counts always match the list.
            get domainsInScope() {
                /** @type {DomainResult[]} */
                let domainsInView = []
                if(this.multiSearch) {
                    domainsInView.push(...this.inUseSearchResults)
                } else {
                    const parts = this.searchBarValue.split(".")[0]
                    for(const tld of this.expandedTldsFromCategories) {
                        const result = this.inUseSearchResults.find(
                            result => (
                                parts == result.nameWithoutTld &&
                                result.name.toLowerCase().replace(
                                    /^[^.]*/,
                                    ""
                                ) == tld
                            )
                        )
                        if(result) {
                            domainsInView.push(result)
                        }
                    }
                }
                return domainsInView
            },
            get domainList() {
                // Copy so the sort below doesn't mutate the domainsInScope cache
                let domainsInView = this.domainsInScope.slice()

                switch(this.showAvailable) {
                    case "all":
                        break
                    case "transfer":
                        domainsInView = domainsInView.filter(
                            d => d.status.can && d.status.can.match(/transfer/)
                        )
                        break
                    default:
                        domainsInView = domainsInView.filter(d => (
                            d.status.can &&
                            d.status.can == this.showAvailable
                        ))
                        break
                }

                if(this.maxPrice > 0) {
                    const start = domainsInView.length
                    domainsInView = domainsInView.filter(d => (
                        d.pricingOptions &&
                        d.pricingOptions.length &&
                        d.status instanceof DRStatus &&
                        d.status.oneYearPrice !== null &&
                        (d.status.oneYearPrice < +this.maxPrice)
                    ))
                    if(start > 0 && !domainsInView.length) {
                        this.maxPriceRemovesRemainder = true
                    }
                }

                return domainsInView.sort((a, b) => {
                    switch(this.sortOrder) {
                        case "price":
                            const aTLD = a.name.replace(/^[^.]*/, "")
                            const bTLD = b.name.replace(/^[^.]*/, "")
                            /**
                             *
                             * @param {SBDomainProduct|DACDomainProduct} p
                             */
                            function _p(p) {
                                if((typeof SBDomainProduct !== 'undefined') && (p instanceof SBDomainProduct)) {
                                    for(const v of p.pricing) {
                                        if(v.periodMonths == 12) {
                                            return v.price || 0
                                        }
                                    }
                                    return 0
                                } else {
                                    return p.anyPrice.purchase
                                }
                            }

                            function filterObject(obj, callback) {
                                return Object.fromEntries(Object.entries(obj).
                                  filter(([key, val]) => callback(val, key)))
                            }

                            /**
                             * Filter out hidden products when dealing with hostshop
                             */
                            const product_by_tld = (typeof SDomainStore !== 'undefined') && (a.domainStore instanceof SDomainStore) ?
                                filterObject(this.domainStore.productByTld, p => !p.hidden) :
                                this.domainStore.productByTld

                            if(product_by_tld && product_by_tld[aTLD]) {
                                return(
                                    _p(product_by_tld[aTLD]) -
                                    _p(product_by_tld[bTLD])
                                )
                            } else {
                                return 0
                            }
                        case "domain":
                            return a.name.localeCompare(b.name)
                        default:
                            // keep existing order
                            return 0
                    }
                })
            },
            // For compat
            get domains() {
                return this.searchResults
            },
            /** @type {string[]} */
            get expandedTldsFromCategories() {
                const tld = []
                for(const c of this.selectedCategory) {
                    if(this.domainCategory && this.domainCategory[c]) {
                        tld.push(...this.domainCategory[c])
                    }
                }
                return tld
            },
            /** @type {boolean} */
            get hasReseller() {
                return this.domainStore && this.domainStore.userInfoGeneral && this.domainStore.userInfoGeneral.isReseller
            },
            /** @type {?DomainResult | undefined} **/
            get inauguralDomain() {
                return this.inUseSearchResults.find(
                    r => r.name == this.searchBarValue
                )
            },
            get inUseSearchResults() {
                return this.queryTld ? this.tldRestrictedSearchResults : this.notHiddenSearchResults
            },
            get noResults() {
                return this.searchBarValue && !this.searchInProgress
            },
            get parseQuery() {
                const query = window.location.search.substr(1).split('&')

                if (!query) return null

                /**
                 * @type {{ tld: string }}
                 */
                const queryObj = query.reduce((result, q) => {
                    const qParts = q.split('=')
                    result[qParts[0]] = qParts[1]
                    return result
                }, {})

                return { query, queryObj }
            },
            get searching() {
                return(
                    (this.searchInProgress && !this.domainList.length) ||
                    this.searchBarValue &&
                    this.showAvailable == "all" &&
                    !this.maxPriceRemovesRemainder
                )
            },
            get searchInProgress() {
                return this.searchResults.some(
                    r => !r.status.response
                )
            },

            /**
             * @type {boolean}
             */
            get selected_all_domains() {
                return !this.domainList.filter(
                    domain => domain.mayAddToBasket
                ).some(domain => !domain.status.checked)
            },
            set selected_all_domains(v) {
                if(v) {
                    this.domainList.filter(
                        domain => domain.mayAddToBasket
                    ).forEach(domain => {
                        domain.status.checked = true
                    })

                } else {
                    this.domainList.forEach(domain => {
                        domain.status.checked = false
                    })
                }
            },
            get tldRestrictedSearchResults() {
                return this.searchResults.filter(r => r.name.indexOf(this.queryTld) !== -1)
            },

            get queryTld() {
                if (!this.parseQuery || !this.parseQuery.queryObj) return null

                const { queryObj: { tld } } = this.parseQuery

                return tld
            },

            get isGovUkDomain() {
                if(/\.gov\.uk$/.test(this.inauguralDomain.name)){
                    return true
                }
                return false
            },

            get isSchUkDomain() {
                if(/\.sch\.uk$/.test(this.inauguralDomain.name)){
                    return true
                }
                return false
            },

            /**
             * When clicking "Add selected domains to basket" button
             *
             * @param {boolean} [silent]
             */
            async add_domains_to_basket(silent = false) {
                const fd = this.domainList.filter(
                    domain => domain.status.checked
                )

                for(const domain of fd) {
                    await domain.addToBasket(silent)
                }
                this.basketClient.reloadContent(silent)
            },
            /**
             *
             * @param {DomainResult} domain
             * @returns {boolean}
             */
            canBasket(domain) {
                return !domain.status.in_basket && !domain.status.disableLock
            },
            /**
             *
             * @param {DomainResult} domain
             * @returns {?boolean}
             */
            canSelectYears(domain) {
                return(
                    this.canBasket(domain) &&
                    domain.status.connected_to_registrar &&
                    !domain.status.disabled &&
                    domain.status.can_class != "unsupported"
                )
            },
            /**
             *
             * @param {DomainResult} domain
             * @returns {boolean}
             */
            disabledButton(domain) {
                return(
                    (!domain.status.connected_to_registrar) ||
                    domain.loading_data ||
                    domain.status.disabled ||
                    !domain.pricingOptions.length
                )
            },
            formatDomainPricing(state) {
                if (!state.id) {
                    return state.text
                  }

                  const splitText = state.text.split('for ')
                  const stitchedText = `<span style="display: inline-block; width: 100%; text-align: center;">${splitText[0]} <strong>${splitText[1]}</strong></span>`

                  return $(stitchedText)
            },
            /**
             * @param {string} availType
             * @returns {number?}
             */
            getAvailabilityCount(availType) {
                if (!this.searchBarValue) return null

                // Count against the same base and classification domainList
                // uses, via the status.can getter (which remaps
                // register-if-has-right, undelete and owned->taken) - not the
                // raw _status._can - so these counts match the filtered list.
                const inScope = this.domainsInScope

                if (availType === 'all') {
                    return inScope.length
                }

                const filteredDomains = inScope.filter(dom => {
                    const can = dom.status.can
                    if (!can) {
                        return false
                    }
                    if (availType === 'transfer') {
                        return !!can.match(/transfer/)
                    } else if (availType === 'register') {
                        return can === 'register'
                    }
                    return false
                })

                return filteredDomains.length
            },
            /**
             * @param {string} cat The category name
             * @return {number}
             */
            getCategoryCount(cat) {
                if((typeof DomainStore !== 'undefined') && (this.domainStore instanceof DomainStore)) {
                    if(this.domainCetegoryCountsByPrice[cat]) {
                        const total = this.domainCetegoryCountsByPrice[cat].length
                        if(total > 0 && !this.selectedsingleCategory) {
                            this.selectedsingleCategory = cat
                        }
                        return total
                    }

                    return 0
                } else {
                    const product_by_tld = this.domainStore.productByTld
                    if(product_by_tld) {
                        var total = this.domainCategory[cat].filter(
                            d => !!product_by_tld[d]
                        ).length
                        if( total > 0 && !this.selectedsingleCategory ){
                            this.selectedsingleCategory = cat;
                        }
                        return total;
                    } else {
                        return 0
                    }
                }
            },
            /**
             * @param {KeyboardEvent} e
             */
            performSearchQuick(e) {
                if(this.lookupWait) {
                    clearTimeout(this.lookupWait)
                }

                switch(e.keyCode) {
                    case 13:
                        // Enter - lets search
                        this.performSearch()
                        break
                    case 189:
                    case 190:
                        // Do nothing if its a full stop or hyphen
                        break
                    default:
                        this.lookupWait = setTimeout(
                            () => this.performSearch(),
                            300
                        )
                }
            },
            /**
             * @param {boolean} [suggestions]
             * @param {?string} [search_term] If supplied, this will set the value
             * to search for
             */
            performSearch(search_term = null, no_detailed = false) {
                // Prevent this from ever being Caps
                if( this.searchBarValue != "" ){

                    var dmString = this.searchBarValue.toLowerCase()

                    var tString = function(string) {
                        while(string.charAt(0)=='-') {
                            string = string.substring(1);
                        }

                        while(string.charAt(string.length-1)=='-') {
                            string = string.substring(0,string.length-1);
                        }

                        return string;
                    }

                    this.searchBarValue = tString(dmString) // this.searchBarValue.toLowerCase()
                }

                if(!search_term) {
                    search_term = this.searchBarValue.toLowerCase()
                }
                if( search_term == "" ){
                    return
                }
                if(search_term.match(/^\s*[a-zA-Z0-9.\r\n,-]*$/)) {
                    search_term = search_term.replace(
                        /(\r?\n)+/g,
                        ","
                    ).replace(
                        /^[^a-zA-Z0-9]*/,
                        ""
                    ).toLowerCase()
                } else {
                    search_term = this.searchBarValue.toLowerCase()
                }

                search_term = this.sanitiseSearchTerm(search_term);

                // Convert non-ASCII labels to punycode for the API request,
                // and build a reverse map so results can be shown as unicode.
                var punycodeToUnicode = {}

                function convertLabelToPunycode(label) {
                    if (/[^\x00-\x7F]/.test(label)) {
                        try {
                            return new URL('https://' + label + '.example.com').hostname.split('.')[0]
                        } catch(e) {
                            return label
                        }
                    }
                    return label
                }

                function convertNameToUnicode(name) {
                    if (!Object.keys(punycodeToUnicode).length) return name
                    return name.split('.').map(function(label) {
                        return punycodeToUnicode[label] || label
                    }).join('.')
                }

                var isIdnSearch = /[^\x00-\x7F]/.test(search_term)
                var punycodeSearchTerm = search_term
                if (isIdnSearch) {
                    punycodeSearchTerm = search_term.split(',').map(function(part) {
                        return part.split('.').map(function(label) {
                            var punycodeLabel = convertLabelToPunycode(label)
                            if (punycodeLabel !== label) {
                                punycodeToUnicode[punycodeLabel] = label
                            }
                            return punycodeLabel
                        }).join('.')
                    }).join(',')
                }

                var searchMatchesDomain = false
                var compiledSearchTerm
                var tldToSearch
                if( !search_term.match(/[a-z0-9][.][a-z]/) ){
                    if(this.expandedDomainSearchDomain != search_term) {
                        this.expandedDomainSearchDomain = search_term
                        this.searchResults = []
                    }
                    var done = {}
                    this.searchResults.forEach( (r) => {
                        done[r.name] = true
                    } )
                    tldToSearch = this.expandedTldsFromCategories.filter(
                        tc => (
                            done[search_term + tc] == undefined &&
                            this.domainStore.productByTld &&
                            !!this.domainStore.productByTld[tc] &&
                            !(isIdnSearch && /\.uk$/.test(tc))
                        )
                    )
                    if(tldToSearch.length) {
                        compiledSearchTerm =
                            punycodeSearchTerm + "," + tldToSearch.join(",")
                    } else {
                        return // Nothing to search for
                    }
                } else {
                    if( search_term.match(/,/) ){
                        searchMatchesDomain = false
                        this.multiSearch = true
                    } else {
                        this.multiSearch = false
                        searchMatchesDomain = true
                    }
                    if (isIdnSearch) {
                        compiledSearchTerm = punycodeSearchTerm
                            .split(',')
                            .filter(d => !/\.uk$/.test(d))
                            .join(',')
                        if (!compiledSearchTerm) return
                    } else {
                        compiledSearchTerm = punycodeSearchTerm
                    }
                }

                if(this.lookupWait) {
                    clearTimeout(this.lookupWait)
                }
                this.lookupWait = null
                if(this.lastRequest) {
                    this.lastRequest.abort()
                }

                // ...
                // jQuery does not actually support incremental load!
                let xhr = new XMLHttpRequest()

                xhr.onabort = () => {
                    var aborted = []
                    if( tldToSearch && tldToSearch.length ){
                        tldToSearch.forEach( (tld) => {
                            let result = this.searchResults.find(
                                result => result.name.toLowerCase() ==
                                    (search_term+tld).toLowerCase()
                            )
                            if( result && result.status.constructor.name != "DRStatus" ){
                                aborted.push( search_term+tld )
                            }
                        } )
                        this.searchResults = this.searchResults.filter( r => !aborted.includes(r.name) )
                    }
                }

                let read_to_offset = 0
                xhr.onprogress = event => {
                    if(read_to_offset < xhr.responseText.length) {
                        var res = {}
                        if(this.basketClient.itemsFlat) {
                            this.basketClient.itemsFlat.filter(
                                i => i.serviceType == "domain"
                            ).forEach(bi => {
                                res[bi.identity.toLowerCase()] = bi
                                try {
                                    res[new URL('https://' + bi.identity).hostname.toLowerCase()] = bi
                                } catch(e) {}
                            })
                        }

                        let buffer = xhr.responseText.substring(read_to_offset)
                        buffer.split(/(\n)/).forEach(part => {
                            if(part.match(/^[\n\[\],]?$/)) {
                                read_to_offset += part.length
                            } else if(part.match(/^{.*}$/)) {
                                let p = JSON.parse(part)
                                if(p.header) {
                                    p.header.names.forEach( (r) => {
                                        var unicodeName = convertNameToUnicode(r)
                                        let result = this.searchResults.find(
                                            result => result.name.toLowerCase() ==
                                                unicodeName.toLowerCase()
                                        )
                                        if( !result ){
                                            var nr = new DomainResult(
                                                unicodeName,
                                                this.domainStore,
                                                this.basketClient,
                                                this.defaultYears
                                            )
                                            if( res[r] || res[unicodeName] ){
                                                nr.basketItem = res[r] || res[unicodeName]
                                                nr.selected_years = nr.basketItem.periodMonths / 12
                                            } else {
                                                nr.basketItem = null
                                            }
                                            this.searchResults.unshift(nr)
                                        }
                                    })
                                } else if(p.name) {
                                    var unicodeResultName = convertNameToUnicode(p.name)
                                    let result = this.searchResults.find(
                                        result => result.name.toLowerCase() ==
                                            unicodeResultName.toLowerCase()
                                    )

                                    if(result) {
                                        try {
                                            result.status = new DRStatus(
                                                p,
                                                this.domainStore,
                                                this.basketClient
                                            )
                                            if( res[p.name] || res[unicodeResultName] ) {
                                                result.status.in_basket = true
                                            }
                                            vue.$nextTick( () => {
                                                $(`[data-toggle="tooltip"]`).tooltip()
                                            } )
                                        } catch(e) {
                                            console.log(e)
                                            console.log(
                                                `Exception when handling ${unicodeResultName}`
                                            )
                                        }
                                    } else {
                                        if(p.can == "suggestion") {
                                            this.searchResults[unicodeResultName] = new DomainResult(
                                                unicodeResultName,
                                                this.domainStore,
                                                this.basketClient,
                                                this.defaultYears
                                            )
                                        } else {
                                            console.log(
                                                `Name ${unicodeResultName} is not in the search set`
                                            )
                                        }
                                    }
                                }
                                read_to_offset += part.length
                            } else {
                                console.log(part)
                            }
                        })
                    }
                }
                xhr.onload = (event) => {
                    if(xhr.status == 429) {
                        alert("Too many searches, please contact support")
                    } else if( searchMatchesDomain ){
                        this.expandedDomainSearchDomain = search_term.replace(/[.].*/, "")
                        this.performSearch( this.expandedDomainSearchDomain )
                    }
                }
                const searchTermEncoded = encodeURIComponent(compiledSearchTerm)
                let args
                if(search_term.match(/[a-z0-9][.][a-z]/)) {
                    args = {
                        noexpand: +true,
                    }
                } else if(compiledSearchTerm.match(/[a-z0-9][.][a-z]/)) {
                    args = {
                        detailed: +false,
                        noexpand: +true,
                    }
                } else {
                    args = {
                        detailed: +false,
                    }
                }
                if (no_detailed === true) {
                    args['detailed'] = +false;
                }
                xhr.open(
                    "GET",
                    `${appPrefix}/a/domain-search/${searchTermEncoded}?` +
                        $.param({
                            ...args
                        })
                )
                this.lastRequest = xhr
                xhr.send()
            },
            resetFilters() {
                this.sortOrder = 'recommended'
                this.showAvailable = "all"
                this.maxPrice = 0.00

                // v-model not used for max price instead v-on:input
                // in order to implement debounce :| Got to update input manually
                const el = document.getElementById('maxPrice')
                if(el) {
                    el.value = ""
                }

            },

            sanitiseSearchTerm(searchTerm) {
                // Simple sanitise to prevent infinate loading
                // We may in the future want to compile a new list of
                // domains and search eg "foo.co.uk,f-o-o.co.uk"

                // Remove any spaces ' '
                var searchTermResult = searchTerm.replace(/ /g,"");

                // Remove any + sign
                searchTermResult = searchTermResult.replace(/\+/g,"");

                // Set the search bar to match, without this nothing shows
                if( searchTermResult != searchTerm ){
                    this.searchBarValue = searchTermResult;
                }
                return searchTermResult;
            },

            // Note if there is no search term in the URL this does nothing!
            startLoadedSearch(){
                if( !this.startLoadedSearchDone ){
                    this.startLoadedSearchDone = true
                    let md
                    if(md = location.search.match(/[?&;]domain=([^&;=]+)/)) {
                        this.searchBarValue = this.sanitiseSearchTerm( decodeURIComponent(md[1].toLowerCase()) )
                        this.performSearch()
                    }
                }
            },

            /**
             *
             * @param {DomainResult} domain
             * @param {boolean} [silent]
             */
            async toggle_domain_basket(domain, silent = false) {
                if(domain.tld == ".ai") {
                    domain.selected_years = 2;
                }
                if(domain.basketItem) {
                    return await this.basketClient.removeItem(domain.basketItem)
                } else if(domain.mayAddToBasket) {
                    domain.status.checked = false
                    if(domain.status.needsDetailCheck) {
                        await new Promise(
                            resolve => domain.checkDetailed(resolve)
                        )
                    }
                    await domain.addToBasket(silent)
                }
            },

            /**
             * @param {string} so The sort order
             */
            togglesortOrder(so) {
                if( this.sortOrder != so ){
                    this.sortOrder = so
                } else {
                    this.sortOrder = null
                }
            },

            /**
             *
             * @param {DomainResult} domain
             */
            async undelete(domain) {
                const result = await this.domainStore.undelete(domain.name)
                if(result) {
                    this.undeleted.push(domain.name)
                }
            },

            updateShowAvailable(value) {
                vue.showAvailable = value
            },

            updateSelectedSingleCategory(value) {
                vue.selectedsingleCategory = value
            }
        }
    },
    methods: {
        formatDiscountResults(option){
            if(option.ogPrice) {
                return $(`<span>${option.text} <s>${option.ogPrice}</s> <b>${option.price}</b></span>`)
            }
            return $(`<span>${option.text}</span>`)
        },
        formatResults: function (option) {
            return $(`<span>${option.text} <small>(${option.count})</small></span>`)
        },
        performAiSearch() {
            if (this.aiSearchBarValue.length > 200) {
                alert("Prompt must not exceed 200 characters");
                return false;
            }
            this.generatingAiSuggestions = true;
            let prompt = this.aiSearchBarValue;
            const promptEncoded = new URLSearchParams({ prompt });

            $.ajax(`/a/ai-domain-search?${promptEncoded.toString()}`)
                .then(res => {
                    if (res.results) {
                        const suggestions = res.results.join(',');
                        this.searchResults = [];
                        this.performSearch(suggestions, true);
                    }
                }).catch(err => {
                    alert("An error occurred. Please try again or contact support.");
                    console.error(err);
                }).always(() => {
                    this.generatingAiSuggestions = false;
                });
        },
        setMaxPrice(e) {
            const v = e.target.value
            if(v && v !== "") {
                if(this.maxPriceDebounceTimeout) {
                    clearTimeout(this.maxPriceDebounceTimeout)
                }
                this.maxPriceDebounceTimeout = setTimeout(() => {
                    this.maxPrice = v
                }, 600)
            } else {
                if(this.maxPriceDebounceTimeout) clearTimeout(this.maxPriceDebounceTimeout)
                this.maxPrice = 0.00
            }
        }
    },
    computed: {
        agencyHubNoReseller() {
            return (this.userInst.hasAgencyHub && !this.userInst.hasReseller);
        },
        categoryListOptions() {
            return this.categorylist ? this.categorylist.map(c => {
                return { id: c, text: c, count: this.getCategoryCount(c) }
            }).filter(c => c.count > 0) : []
        },
        domainCategoryPriceMap() {
            /** This does not need to be computed */
            if((typeof DomainStore !== 'undefined') && (this.domainStore instanceof DomainStore)) {
                const out = {}
                for(const c in this.domainCategory) {
                    out[c] = this.domainCategory[c].map(el => {
                        if(this.domainStore && this.domainStore.productByTld && this.domainStore.productByTld[el]) {
                            return {
                                tld: el,
                                price: this.domainStore.productByTld[el].anyPrice
                            }
                        }
                    }).filter(el => el !== undefined)
                }

                return out
            }
        },
        domainCetegoryCountsByPrice() {
            if(this.maxPrice) {
                const out = {}

                for(const c in this.domainCategoryPriceMap) {
                    out[c] = this.domainCategoryPriceMap[c].filter(el => el.price.purchase <= this.maxPrice)
                }

                return out
            }

            return this.domainCategoryPriceMap
        },
    },
    watch: {
        useAiSearch() {
            this.searchBarValue = '';
            this.aiSearchBarValue = '';
        },
        search(v) {
            this.performSearch()
        },
        searchQuick(v) {
            this.searchBarValue = v.target.value
            this.performSearchQuick(v)
        },
        "basketClient.itemsFlat": function(v) {
            if(v) {
                v = v.filter(i => i)
                const res = {}
                for(const bi of v) {
                    res[bi.identity.toLowerCase()] = bi
                    try {
                        res[new URL('https://' + bi.identity).hostname.toLowerCase()] = bi
                    } catch(e) {}
                }
                for(const dr of this.searchResults) {
                    if(res[dr.name.toLowerCase()]) {
                        dr.basketItem = res[dr.name.toLowerCase()]
                        dr.selected_years = dr.basketItem.periodMonths / 12
                        dr.status.in_basket = true
                    } else if (dr.status) {
                        dr.basketItem = null
                        dr.status.in_basket = false
                    }
                }
            }
        },
        "domainStore.productByTld": function(v){
            if(v && this.domainCategory){
                this.startLoadedSearch()
                if( !this.initialBuild ){
                    this.initialBuild = true
                    var allDomains = []
                    Object.keys(this.domainCategory).forEach( (key) => {
                        this.domainCategory[key].forEach( (d) => {
                            if( !allDomains.includes(d) ){
                                allDomains.push(d)
                            }
                        } )
                        if( key != "Popular" && key != "New" ){
                            this.domainCategory[key].sort()
                        }
                    } )
                    Object.keys(v).forEach( (tld) => {
                        if( !allDomains.includes(tld) ){
                            this.domainCategory["New"].push(tld)
                        }
                    } )
                }
            }
        },
        selectedCategory() {
            this.performSearch()
        },

        selectedsingleCategory(n) {
            if(n) {
                this.selectedCategory = [n]
            }
        },
    },
    components: {
        vueSelect: VueSelect,
        customRadio: CustomRadio
    },
    mounted() {
        this.domainStore.preload([
            "productByTld",
            "transferProductByTld",
            "userInfoGeneral",
            "yearsByTld"
        ])

        $(document).on("hashchange", () => this.performSearch())
    },
})

// This is DEPRECATED. Once www no longer needs it, it gets dropped.
Vue.component("domain-search", DomainSearch)
